// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bsc as _bsc } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bsc chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 56
 * Chain Name: BNB Smart Chain
 * Default Block Explorer: https://bscscan.com
 * Default RPC URL: https://rpc.ankr.com/bsc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bsc } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bsc,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bsc = createCommon({
	..._bsc,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
